import autoAnimate from "@formkit/auto-animate";
import motion from "../../motion-tokens.json" with { type: "json" };
import { registerList } from "../view-transition";

/**
 * x-list-motion on a list's parent, the one directive a moving list needs (D58, D74): rows that arrive,
 * leave or re-rank move into place. Its owner makes each change through $moveRows(update), which names
 * this list's rows for a view transition on the `morph` token where the browser has the API; elsewhere
 * auto-animate moves them as the DOM changes, so a row is never animated twice. auto-animate draws an
 * arriving row over 1.5 times its duration, so it runs on the `show` token: on `morph` an arrival would
 * take 540 ms, past the `view` token every animation stays within. Under reduced motion neither runs:
 * $moveRows makes the change at once, and auto-animate stands still on its own.
 *
 * A row travels on its own when it carries a key (data-motion-key, wire:key, data-row-id or id).
 */
export function ListMotionDirective(el, _directive, { cleanup }) {
    cleanup(registerList(el));

    if (typeof document.startViewTransition === "function") {
        return;
    }

    const controller = autoAnimate(el, {
        duration: motion.duration.show,
        easing: motion.ease,
    });

    cleanup(() => controller.disable());
}
